import React, { Component } from "react";
import ModalVideo from "react-modal-video";
import sectionImage from "../images/section-icon.png";
import videoImage from "../images_new/DSC02112.png";
import "react-modal-video/css/modal-video.min.css";

class EntryArea extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
  }
  componentDidMount(){
    this.mounted = true;
  }

  handleModal = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };
  render() {
    return (
      <React.Fragment>
        <section className="entry-area">
          <div className="container">
            <div className="row entry-static-wrap">
              <div className="col-lg-3">
                <div className="entry-static-box entry-static-box1">
                  <div className="section-icon">
                    <img src={sectionImage} alt="section-icon" />
                  </div>
                  <h4 className="entry__title">Hunger is stalking the globe</h4>
                </div>
              </div>
              <div className="col-lg-9">
                <div className="entry-static-box entry-static-box2 d-flex align-items-center">
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="entry-video-img">
                        <img src={videoImage} alt="entry-video-img" />

                        <div
                          onClick={this.handleModal}
                          onKeyUp={this.handleModal}
                          role="button"
                          tabIndex="0"
                          className="mfp-iframe video-play-btn"
                          title="Play Video"
                        >
                          <i className="fa fa-play"></i>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-8">
                      <div className="entry-video-text">
                        <h4 className="entry__title">
                          We are here to support you every step of the way.
                        </h4>
                        <p className="entry__text">
                          Watch us how we take care of everyone
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {this.mounted && (
          <ModalVideo
            channel="youtube"
            isOpen={this.state.isOpen}
            videoId="RQu7jpcNUWI"
            onClose={() => this.setState({ isOpen: false })}
          />
        )}
      </React.Fragment>
    );
  }
}

export default EntryArea;
